const faqs = [
  {
    q: '人人影视是否需要注册才能观看？',
    a: '不需要。人人影视所有高清免费在线观看资源均支持免注册直接播放，打开即看。如果希望收藏剧集或订阅更新提醒，可以选择注册账号享受更多便捷功能。',
  },
  {
    q: '为什么人人影视的播放速度这么快？',
    a: '人人影视采用自研极速播放引擎，配合全球多节点CDN加速网络，从技术层面确保不缓冲秒播。无论使用电脑、平板还是手机，都能获得流畅的高清观影体验。',
  },
  {
    q: '人人影视的资源画质如何？',
    a: '全站资源默认提供1080P高清画质，部分热门剧集支持4K超高清播放。系统会自动检测您的网络状况并匹配最佳清晰度，您也可以手动切换画质选项。',
  },
  {
    q: '人人影视的更新频率是怎样的？',
    a: '人人影视每日同步更新海内外最新影视内容。热播剧集通常在播出后2小时内上线中文字幕版，电影、综艺、动漫等也会在第一时间跟进，确保您不会错过任何精彩。',
  },
  {
    q: '人人影视支持哪些设备观看？',
    a: '人人影视全面支持电脑网页端、手机浏览器、平板设备在线观看。同时提供移动客户端APP，适配iOS与Android系统，让您随时随地畅享高清不缓冲秒播体验。',
  },
];

export default function FaqSection() {
  return (
    <section
      id="faq"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50 scroll-mt-16"
    >
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          常见问答
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((faq) => (
            <details
              key={faq.q}
              className="group rounded-lg bg-background-100 border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-800 list-none">
                <span>{faq.q}</span>
                <i className="ri-arrow-down-s-line text-lg text-foreground-500 group-open:rotate-180 transition-transform"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}